import { Box, Divider, Grid, InputAdornment, Paper, Tab, Tabs, TextField, Typography } from "@mui/material";
import React, { useEffect, useMemo, useRef, useState } from "react";
import { TipoPedido } from "../../../pedidos/enum/TipoPedido";
import { IProdutoPedido } from "../../../pedidos/interface/IProdutoPedido";
import { CardIndustrializadoOperacao } from "../../components/CardIndustrializadoOperacao";
import { CardPizzaOperacao } from "../../components/CardPizzaOperacao";
import { CardProdutoCarrinhoOperacao } from "../../components/CardProdutoCarrinhoOperacao";
import { useFetchCategorias } from "../../hooks/useFetchCategorias";
import { ICategoria } from "../../interfaces/ICategoria";
import { GridCarrinho, GridProdutos, ListarCategoriasContainer } from "./styles";
import { TipoProduto } from "../../enum/TipoProduto";
import { IProduto } from "../../interfaces/IProduto";
import { CardPreparadoOperacao } from "../../components/CardPreparadoOperacao";
import { CardPesoOperacao } from "../../components/CardPesoOperacao";
import { CardComboOperacao } from "../../components/CardComboOperacao";
import SearchIcon from '@mui/icons-material/Search';
import { useLetras } from "../../../core/hooks/useLetras";
import { useTamanhoTela } from "../../../core/hooks/useTamanhoTela";
import { ProdutosCarrinhoContainer } from "../ProdutosCarrinhoContainer";
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import { TipoMarketplace } from "../../../marketplace/enum/TipoMarketplace";
import moment from "moment";
import { DiaSemanaOrdem } from "../../../core/enum/DiaSemana";
import { useModoTeclado } from "../../../core/hooks/useModoTeclado";
import { AtalhosTeclado } from "../../../core/components/AtalhosTeclado";
import { useOperacaoContext } from "../../../pedidos/contexts/OperacaoContext";
interface OperacaoCategoriasProdutosProps {
    adicionarProduto: (produto: IProdutoPedido) => void;
    adicionarProdutosComboExterno?: (produtos: IProdutoPedido[]) => void;
    contexto: TipoPedido;
    categorias: ICategoria[];
    carrinhoContainer: React.ReactNode;
    cliente?: any;
    endereco?: any;
    mesaId?: number;
    fecharPedido?: () => void;
}

const renderizarProdutos = (
    produtos: IProduto[] | undefined,
    adicionarProduto: (produto: IProdutoPedido) => void,
    adicionarProdutosCombo: (produtos: IProdutoPedido[]) => void,
    modoTeclado: boolean,
    indiceSelecionado: number,
    cardsRefs: React.MutableRefObject<(HTMLDivElement | null)[]>
) => {
    return produtos?.map((produto, index) => {
        const isSelecionado = modoTeclado && index === indiceSelecionado;

        return (
            <Grid
                item
                xs={6}
                md={4}
                lg={12/5}
                key={produto.uuid}
                ref={(el) => {
                    cardsRefs.current[index] = el;
                }}
            >
                {produto.tipo == TipoProduto.pizza && (
                    <CardPizzaOperacao
                        produto={produto}
                        adicionarProduto={adicionarProduto}
                        modoTeclado={modoTeclado}
                        isSelecionado={isSelecionado}
                    />
                )}
                {produto.tipo == TipoProduto.preparado && (
                    <CardPreparadoOperacao
                        produto={produto}
                        adicionarProduto={adicionarProduto}
                        modoTeclado={modoTeclado}
                        isSelecionado={isSelecionado}
                    />
                )}
                {produto.tipo == TipoProduto.industrializado && (
                    <CardIndustrializadoOperacao
                        produto={produto}
                        adicionarProduto={adicionarProduto}
                        modoTeclado={modoTeclado}
                        isSelecionado={isSelecionado}
                    />
                )}
                {produto.tipo == TipoProduto.peso && (
                    <CardPesoOperacao
                        produto={produto}
                        adicionarProduto={adicionarProduto}
                        modoTeclado={modoTeclado}
                        isSelecionado={isSelecionado}
                    />
                )}
                {produto.tipo == TipoProduto.combo && (
                    <CardComboOperacao
                        produto={produto}
                        adicionarProdutosCombo={adicionarProdutosCombo}
                        modoTeclado={modoTeclado}
                        isSelecionado={isSelecionado}
                    />
                )}
            </Grid>
        );
    })
}

export const OperacaoCategoriasProdutosContainer = ({ categorias, carrinhoContainer, contexto, adicionarProduto, adicionarProdutosComboExterno, cliente, endereco, mesaId, fecharPedido }: OperacaoCategoriasProdutosProps) => {
    const { produtos, adicionarProdutosCombo: adicionarProdutosComboContexto } = useOperacaoContext();
    const adicionarProdutosCombo = adicionarProdutosComboExterno ?? adicionarProdutosComboContexto;
    const [categoria, setCategoria] = useState<ICategoria>();
    const { maiusculas, removerAcentos, removerCedilha } = useLetras();
    const [pesquisa, setPesquisa] = useState<string>('');
    const [pesquisaDebounced, setPesquisaDebounced] = useState<string>('');
    
    // Debounce para o filtro
    useEffect(() => {
        const timer = setTimeout(() => {
            setPesquisaDebounced(pesquisa);
        }, 300); // 300ms de delay
        
        return () => clearTimeout(timer);
    }, [pesquisa]);
    
    const limparInput = () => {
        setPesquisa('');
        
        const seletores = [
            'input[placeholder*="Pesquisa"]',
            'input[placeholder*="pesquisa"]',
            'input[placeholder*="Buscar"]',
            'input[placeholder*="buscar"]',
            '.MuiInputBase-input',
            'input[type="text"]'
        ];
        
        let inputElement: HTMLInputElement | null = null;
        
        for (const seletor of seletores) {
            inputElement = document.querySelector(seletor) as HTMLInputElement;
            if (inputElement) {
                break;
            }
        }
        
        if (inputElement) {
            inputElement.value = '';
            const inputEvent = new Event('input', { bubbles: true });
            inputElement.dispatchEvent(inputEvent);
        }
    };

    const diaAtual = moment().day(); 
    const horaAtual = moment(); 

    const categoriasFiltradas = useMemo(() => {
        const filtradas = categorias?.filter(categoria => {
            if (!categoria.periodosExibicao?.length) {
                return true; 
            }
    
            return categoria.periodosExibicao.some(periodo => {
                if (DiaSemanaOrdem[periodo.diaSemana] !== diaAtual) {
                    return false; 
                }

                return periodo.horarios.some(horario => {
                    const horaInicio = moment(horario.inicio, 'HH:mm');
                    const horaFim = moment(horario.fim, 'HH:mm');

                    return horaAtual.isBetween(horaInicio, horaFim); 
                });
            });
        })

        return filtradas;
    }, [categorias]);

    const produtosAtivos = categoria?.produtos?.filter(produto => !produto.inativadoAs && !produto.apenasCombo);

    const handleChange = (event: React.SyntheticEvent, novaTab: string) => {
        setPesquisa('');
        setCategoria(categorias.find(categoria => categoria.uuid == novaTab));
    };

    function tabProps(uuid: string) {
        return {
            id: `simple-tab-${uuid}`,
            'aria-controls': `simple-tabpanel-${uuid}`,
        };
    }

    const produtosFiltrados = useMemo(() => {
        const produtos: IProduto[] = [];

        if (!pesquisaDebounced?.length) {
            return produtos;
        }

        categoriasFiltradas.map(categoria => {
            const categoriaPDV = categoria.marketplaces?.filter(marketplace => marketplace.tipo == TipoMarketplace.PDV)
            if (categoriaPDV?.length && categoria.contextos?.includes(contexto)) {
                categoria.produtos?.filter(produto => {
                    const strDescricao = removerAcentos(removerCedilha(maiusculas(produto.descricao)));
                    const strPesquisa = removerAcentos(removerCedilha(maiusculas(pesquisaDebounced)));

                    if (strDescricao.includes(strPesquisa) && produto.inativadoAs == undefined && !produto.apenasCombo) {
                        return true;
                    }

                    return false;
                })
                .map(produto => produtos.push(produto));
            }
        })

        return produtos;
    }, [categoria, pesquisaDebounced])

    // Renomear um produto dentro do combo NÃO o transforma em outro produto — é o mesmo item,
    // só chamado de outra forma ali. Portanto, resolvemos o nome ORIGINAL de cada item do combo
    // (via produtoOrigemUuid) para que o lançamento financeiro use o nome original.
    const mapaTodosProdutos = useMemo(() => {
        const mapa = new Map<string, IProduto>();
        (categorias ?? []).forEach(c => c.produtos?.forEach(p => { if (p.uuid) mapa.set(p.uuid, p); }));
        return mapa;
    }, [categorias]);

    const resolverOrigemCombo = (produto: IProduto): IProduto => {
        if (produto.tipo !== TipoProduto.combo || !produto.itensCombo?.length) {
            return produto;
        }
        return {
            ...produto,
            itensCombo: produto.itensCombo.map(item => {
                const filho = item.produto;
                if (!filho || filho.descricaoOrigem || !filho.produtoOrigemUuid || filho.produtoOrigemUuid === filho.uuid) {
                    return item;
                }
                const original = mapaTodosProdutos.get(filho.produtoOrigemUuid);
                return original?.descricao ? { ...item, produto: { ...filho, descricaoOrigem: original.descricao } } : item;
            }),
        };
    };

    // Hook para modo teclado
    const produtosParaNavegacao = produtosFiltrados.length ? produtosFiltrados : produtosAtivos || [];
    const {
        modoTeclado,
        indiceSelecionado,
        filtroFocado,
        setFiltroFocado,
        inputFiltroRef,
        cardsRefs,
        areaProdutosRef,
        focarFiltro,
        sairModoTeclado,
        reativarModoTeclado
    } = useModoTeclado({
        produtos: produtosParaNavegacao,
        onProdutoSelecionado: (produto) => {
            adicionarProduto({ ...produto, uuidProdutoReferencia: produto.uuid });
        },
        onTeclaDigitada: (tecla) => {
            if (tecla === 'Enter') {
                return;
            }
            
            setPesquisa(prev => prev + tecla);
        },
        onF8Pressed: () => {
            window.dispatchEvent(new CustomEvent('limparFiltroProdutos'));
            window.dispatchEvent(new CustomEvent('resetarModoTeclado'));
            limparInput();
            if (fecharPedido) {
                fecharPedido();
            }
        }
    });

    useEffect(() => {
        if (modoTeclado && produtos.length > 0) {
            const timer = setTimeout(() => {
                reativarModoTeclado();
            }, 200);
            
            return () => clearTimeout(timer);
        }
    }, [produtos, modoTeclado, reativarModoTeclado]);

    useEffect(() => {
        if (categoriasFiltradas && categoriasFiltradas.length) {
            const indexCategoria = categoriasFiltradas.findIndex(categoria => 
                categoria?.contextos?.includes(contexto) && 
                categoria?.marketplaces &&
                (categoria?.marketplaces?.filter(marketplace => marketplace.tipo == TipoMarketplace.PDV).length) > 0
            );
            if (indexCategoria != -1) {
                setCategoria(categoriasFiltradas[indexCategoria]);
            }
        }
    }, [categoriasFiltradas])

    useEffect(() => {
        const handleLimparFiltro = () => {
            limparInput();
        };

        const handleResetarModoTeclado = () => {
            setTimeout(() => {
                sairModoTeclado();
            }, 200);
        };

        window.addEventListener('limparFiltroProdutos', handleLimparFiltro);
        window.addEventListener('resetarModoTeclado', handleResetarModoTeclado);
        
        return () => {
            window.removeEventListener('limparFiltroProdutos', handleLimparFiltro);
            window.removeEventListener('resetarModoTeclado', handleResetarModoTeclado);
        };
    }, [modoTeclado, indiceSelecionado, sairModoTeclado]);

    useEffect(() => {
        if (pesquisa?.length) {
            setCategoria(undefined);
            return;
        } else {
            setTimeout(() => {
                const indexCategoria = categoriasFiltradas.findIndex(categoria => 
                    categoria?.contextos?.includes(contexto) && 
                    categoria?.marketplaces &&
                    (categoria?.marketplaces?.filter(marketplace => marketplace.tipo == TipoMarketplace.PDV).length) > 0
                );
                if (indexCategoria != -1 && !categoria) {
                    setCategoria(categoriasFiltradas[indexCategoria]);
                }
            }, 500)
        }

    }, [categoria, pesquisa])

    return (
        <ListarCategoriasContainer ref={areaProdutosRef}>
            <Box sx={{ padding: "0.5rem 1rem", display: "flex", width: "100%", justifyContent: "space-between", alignItems: "center" }}>
                <Tabs
                    value={categoria?.uuid}
                    onChange={handleChange}
                    variant="scrollable"
                    allowScrollButtonsMobile
                    sx={{ width: "80%" }}
                >
                    {categoriasFiltradas?.map(categoriaMap => {
                        const categoriaPDV = categoriaMap.marketplaces?.filter(marketplace => marketplace.tipo == TipoMarketplace.PDV)
                        if (categoriaMap?.contextos?.includes(contexto) == true && categoriaPDV?.length && categoriaMap.uuid) {
                            return (
                                <Tab
                                    {...tabProps(categoriaMap.uuid)}
                                    key={categoriaMap.uuid}
                                    value={categoriaMap.uuid}
                                    label={categoriaMap.descricao}
                                />
                            )
                        }
                    })}
                </Tabs>
                <TextField
                    ref={inputFiltroRef}
                    size="small"
                    placeholder="Pesquisa"
                    value={pesquisa}
                    onChange={(e) => setPesquisa(e.target.value)}
                    onFocus={() => setFiltroFocado(true)}
                    onBlur={() => setFiltroFocado(false)}
                    InputProps={{
                        startAdornment: (
                            <InputAdornment position="start">
                                <SearchIcon color="disabled" />
                            </InputAdornment>
                        ),
                    }}
                    sx={{ 
                        width: "200px",
                        ...(filtroFocado && {
                            '& .MuiOutlinedInput-root': {
                                borderColor: 'primary.main',
                                boxShadow: '0 0 0 2px rgba(25, 118, 210, 0.2)'
                            }
                        })
                    }}
                />
            </Box>
            <GridProdutos container spacing={2}>
                {produtosFiltrados.length ?
                    renderizarProdutos(produtosFiltrados.map(resolverOrigemCombo), adicionarProduto, adicionarProdutosCombo, modoTeclado, indiceSelecionado, cardsRefs) :
                    renderizarProdutos(produtosAtivos?.map(resolverOrigemCombo), adicionarProduto, adicionarProdutosCombo, modoTeclado, indiceSelecionado, cardsRefs)
                }
            </GridProdutos>
            <GridCarrinho >
                <Grid container sx={{ marginTop: "0.2rem" }}>
                    {carrinhoContainer}
                </Grid>
            </GridCarrinho>
            <AtalhosTeclado modoTeclado={modoTeclado} filtroFocado={filtroFocado} />
        </ListarCategoriasContainer>
    );
}